export default __webpack_public_path__ + "static/larissa@2x-0d6421b072d6258aa93c364cedf3d75e.png";